function escapeRegExp(value) {
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}

function isSameQuery(query, q) {
    if (!q && query && !query.fullText) return true
    if (q && query && q == query.fullText) return true
    return false
}

function isSubQuery(query, q) {
    if (!q && query && !query.fullText) return true
    if (q && query && q.startsWith(query.fullText)) return true
    return false
}

function isFullRange(range) {
    if (range && (range.count == 0) || (range.limit == range.count - 1)) return true
    return false
}

export function streamMatcher({stream, range, query, identify=(v) => v, load}) {
    var loading = false

    return (q, cb) => {
        if (loading) {
            // skip
        } else if (!isSubQuery(query, q) || (!isSameQuery(query, q) && !isFullRange(range))) {
            loading = true
            load(q)
            // skip
        } else if (!q) {
            const matches = stream
            cb(matches)
        } else {
            const regexp = new RegExp(escapeRegExp(q), 'i')
            const matches = stream.filter((value) => regexp.test(identify(value)))
            cb(matches)
        }
    }
}

export default function({source, identify=(v) => v}) {
    return (q, cb) => {
        var matches

        if (q) {
            const regexp = new RegExp(escapeRegExp(q), 'i')
            matches = source.filter((value) => regexp.test(identify(value)))
        } else {
            matches = source
        }

        cb(matches)
    }
}


// WEBPACK FOOTER //
// ./lib/core/matcher.js